import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/yelp': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M42.9 240.3l99.6 48.6c19.2 9.4 16.2 37.5-4.5 42.7l-107.5 26.8c-1.5 0.4-4 0.7-5.6 0.7-11.3 0-21.4-9.1-22.7-20.3-0.7-6.2-1.3-16.3-1.3-22.5 0-17.8 4.6-46 10.3-62.8 2.9-8.6 12.6-15.5 21.6-15.5 2.9 0 7.4 1 10 2.3zM86.9 479.6c-5.5-3.8-9.9-12.2-9.9-18.8 0-4.8 2.6-11.7 5.8-15.3l74.2-82.4c14.3-15.8 40.5-5.2 39.8 16.1l-3.9 110.8c-0.4 12.1-10.6 22-22.8 22-1.1 0-2.8-0.1-3.9-0.3-23.9-4-59.4-18.4-79.4-32.1zM232.2 369.7c-11.3-18.1 6.2-40.4 26.5-33.9l105.4 34.3c8.7 2.9 15.7 12.7 15.7 21.8 0 2.8-1 7.2-2.2 9.7-10.4 21.9-34 52.2-52.7 67.6-3.5 2.9-10 5.2-14.6 5.2-7 0-15.7-4.8-19.4-10.7zM380.6 237.4c1 2.4 1.9 6.5 1.9 9.1 0 9.5-7.4 19.4-16.5 22.1l-106.6 30.5c-20.5 5.9-37.1-17-25.2-34.7l62-91.9c3.8-5.6 12.2-10.1 18.9-10.1 4.7 0 11.5 2.5 15.1 5.7 18.2 16 40.8 47.1 50.4 69.3zM62.1 30.2c29.5-14 79.8-27.5 112.3-30.1 0.5 0 1.3-0.1 1.8-0.1 12.5 0 22.7 10.2 22.7 22.7 0 0.1 0 0.1 0 0.2v208.3c0 23.3-30.9 31.6-42.6 11.4l-104.1-180.4c-1.7-2.9-3-8-3-11.4 0-7.9 5.8-17.2 12.9-20.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/yelp.js
// module id = 1111
// module chunks = 0